function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "19",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 8.15c3.175 0 6.36-.57 8.1-1.793V8.15c0 1.487-3.628 2.7-8.1 2.7-4.472 0-8.1-1.213-8.1-2.7V6.357C2.14 7.58 5.325 8.15 8.5 8.15zm0 8.1c3.175 0 6.36-.57 8.1-1.793v1.793c0 1.487-3.628 2.7-8.1 2.7-4.472 0-8.1-1.213-8.1-2.7v-1.793c1.74 1.223 4.925 1.793 8.1 1.793zm0-4.05c3.175 0 6.36-.57 8.1-1.793V12.2c0 1.487-3.628 2.7-8.1 2.7-4.472 0-8.1-1.213-8.1-2.7v-1.793C2.14 11.63 5.325 12.2 8.5 12.2zM8.5.05c4.472 0 8.1 1.213 8.1 2.7V4.1c0 1.487-3.628 2.7-8.1 2.7C4.028 6.8.4 5.587.4 4.1V2.75C.4 1.263 4.028.05 8.5.05z",
  fill: "#888",
  fillRule: "evenodd"
})));